export const InfoCard = ({ title, rows, testId }) => (
  <div className="bg-white border border-stone-200 rounded-lg p-6 h-fit" data-testid={testId}>
    <h3 className="font-heading text-base font-bold text-stone-900">{title}</h3>
    <dl className="mt-4 space-y-3 text-sm">
      {rows.map(([k, v]) => (
        <div key={k} className="flex gap-4">
          <dt className="w-32 shrink-0 text-stone-500">{k}</dt>
          <dd className="text-stone-900 break-words min-w-0">{v === 0 ? 0 : v || "—"}</dd>
        </div>
      ))}
    </dl>
  </div>
);

export const Chips = ({ items, tone = "stone", empty = "Aucune" }) => (
  <div className="flex flex-wrap gap-1.5">
    {items.length === 0 && <span className="text-sm text-stone-500">{empty}</span>}
    {items.map((x) => (
      <span key={x} className={`text-xs rounded-md border px-2 py-0.5 ${tone === "red" ? "bg-red-50 text-red-800 border-red-200" : "bg-stone-100 text-stone-700 border-stone-200"}`}>{x}</span>
    ))}
  </div>
);
